export const OAuthSettings = {
  access_token: '',
  token: '',
  scopes: [
  ]
};